<template>
  <div o-Container>
    <o-list v-bind:source="list.sensor" v-bind="{searched:search}"/>
  </div>
</template>


<script>
  export default {
    name: "admin_Dashboard", /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    data() {
      return {
        octopus: this.$parent.octopus,
        list: {
          sensor: {
            data: {
              id: 131, // 菜单表的八爪鱼ID
              cellData: [
                {name: "TypeID", width: 70, searchKey: "="},
                {name: "Title", width: 180, searchKey: "="},
                {name: "Content", width: 800},
                {name: "CreateUserID", width: 100},
                {name: "CreateTime", width: 130},
              ],
            }
          },
        },
      }
    },
    methods: {
      create: function () {
        this.octopus.router.jump("/MMS/Cluster/Build/Modify");
      },
      output: function (data) {
        // 导出以后，回调这里给客户端操作。
        // 核心思想是cellData包含search数据（不管有没有），回传以后发送export指令，后台api会直接返回导出的数据提供下载。
        alert("export: get cell data is " + JSON.stringify(data));
      },
      search: function (cell) {

      },
      modify: function (row) {

      },
      view: function (row) {
        alert("view key: " + JSON.stringify(row));
      },
      del: function (row) {
        alert("del key: " + JSON.stringify(row));
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/MMS/Admin/Dashboard/Page.vue